import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import {
  EveryCard,
  EveryCardBody,
  EveryCardFooter,
  EveryCardHeadline,
  EveryCardPadding
} from 'blocks/EveryCard/EveryCard';
import TagBlock from 'blocks/TagBlock';
import IconComponent from 'components/IconComponent';
import TextElement from 'components/TextElement/TextElement';
import OrganizerConditional from 'domain/Conditionals/OrganizerConditional';
import WordWrap from 'elements/WordWrap';
import { ProfileModelType } from 'models/ProfileModel';
import { RankingModelType } from 'models/RankingModel';
import ROLES from 'utils/constants/roles';
import { ROUTE_RANKINGS } from 'utils/constants/routes';
import RankingOwnVoteComponent from '../RankingOwnVoteComponent';

export const RankingsListItem = ({
  ranking,
  locked,
  currentUser
}: {
  ranking: RankingModelType;
  locked?: boolean;
  currentUser?: ProfileModelType;
}) => {
  const isOrganizer =
    currentUser &&
    (currentUser.role === ROLES.ORGANIZER ||
      currentUser.role === ROLES.MANAGER);
  const isLocked = locked && !isOrganizer;

  const showUrl = isOrganizer ? '/show' : '';

  const count = !ranking.votes_count
    ? 0
    : ranking.num_candidates
    ? Math.floor(ranking.votes_count / ranking.num_candidates)
    : ranking.votes_count;

  const item = (
    <EveryCard topAlign={true}>
      <EveryCardPadding>
        <EveryCardBody>
          <EveryCardHeadline>
            <WordWrap>{ranking.name}</WordWrap>
          </EveryCardHeadline>

          <OrganizerConditional profile={currentUser}>
            <TextElement>
              <FormattedMessage
                id="People voted"
                values={{
                  count
                }}
              />
            </TextElement>
          </OrganizerConditional>

          <TextElement>
            <RankingOwnVoteComponent ranking={ranking} />
          </TextElement>
        </EveryCardBody>

        {ranking.num_candidates === 2 && (
          <TagBlock color="PRIMARY" backgroundColor="PRIMARY_LIGHT">
            <FormattedMessage id="Duo" />
          </TagBlock>
        )}
      </EveryCardPadding>
      {ranking.render_overflow && (
        <EveryCardFooter textStart={true} background="PRIMARY_LIGHT">
          <TextElement color="BLACK">
            <IconComponent icon="WARNING_CIRCLE" fill="WARNING" />
            <FormattedMessage id="Ranking overflow" />
          </TextElement>
        </EveryCardFooter>
      )}
    </EveryCard>
  );

  if (isLocked) {
    return item;
  }

  return (
    <Link
      to={
        ROUTE_RANKINGS + '/' + ranking.chapter_id + '/' + ranking.id + showUrl
      }
    >
      {item}
    </Link>
  );
};

export default RankingsListItem;
